<script setup lang="ts">
import { ref } from "vue";
import NavigationLinks from "./NavigationLinks.vue";
const searchBarMobileVisible = ref(false);
</script>

<template>
  <div class="d-print-none">
    <div class="mobile-status-bar-background" />
    <div class="navigation-bar">
      <div>
        <div class="container">
          <div class="row">
            <div class="col-auto col-brand">
              <router-link to="/" class="brand"
                ><img src="@/assets/images/logo_horiz.svg" alt="" height="32" />
              </router-link>
            </div>
            <div class="col d-none d-md-block">
              <NavigationLinks class="menu-desktop d-md-flex" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 768px) {
  .navigation-bar {
    height: 53px;
  }
}

.navigation-bar > div {
  border-bottom: 3px solid var(--primary-color);
  box-sizing: content-box;
}

.mobile-status-bar-background {
  position: fixed;
  height: 100px;
  top: -100px;
  left: 0;
  right: 0;
  z-index: 9;
  background: var(--black-eigengrau);
}
</style>

<style>
@media (max-width: 767.98px) {
  html.menu-mobile-visible {
    overflow: hidden;
  }

  html.menu-mobile-visible body {
    max-height: 100vh;
    overflow: auto;
  }

  .navigation-bar > div > .container > .row {
    justify-content: center;
  }

  .navigation-bar {
    height: 93px;
    box-sizing: content-box;
  }

  .navigation-bar > div {
    padding: 25px 0 15px 0;
    box-sizing: content-box;
  }
}

.mobile-badge {
  background-color: var(--highlight-color);
  border-radius: 10px;
  position: absolute;
  top: 8px;
  left: 28px;
}

.navigation-bar > div {
  background: var(--black-eigengrau);
  height: 50px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 10;
}

.navigation-bar .col-brand {
  display: flex;
}

.navigation-bar .brand {
  line-height: 50px;
  color: #262c40;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 22px;
  text-decoration: none;
}

.navigation-bar .menu-btn {
  width: 36px;
  height: 34px;
  line-height: 34px;
  padding: 0;
  align-self: center;
  margin-right: 13px;
  font-size: 18px;
}

.menu-desktop {
  display: none;
  list-style: none;
  padding: 0;
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-weight: 300;
}

.menu-desktop > li {
  position: relative;
}

.menu-desktop > li.spacer {
  flex-grow: 1;
}

.menu-desktop > li > a,
.menu-desktop > li > .label-only {
  display: inline-block;
  line-height: 50px;
  color: var(--white-ice);
  font-size: 14px;
  padding: 0 14px;
  text-decoration: none;
}

.menu-desktop > li:hover > a,
.menu-desktop > li:hover > .label-only {
  background: var(--black-highlight);
  color: var(--primary-color);
}

.menu-desktop > li.router-link-exact-active > a {
  font-weight: 500;
}

.menu-desktop > li .caret {
  margin-left: 1px;
}

.menu-desktop > li ul {
  position: absolute;
  list-style: none;
  padding: 10px;
  margin: 0;
  background: var(--black-highlight);
  display: none;
  flex-direction: column;
  border-radius: 0 0 0.25rem 0.25rem;
}

.menu-desktop > li ul li {
  border-radius: 1.125rem;
}

.menu-desktop > li ul li .label-only {
  display: inline-block;
  line-height: 25px;
  width: 200px;
  padding: 0 15px;
  color: #d9d6ce;
  font-size: 14px;
}

.menu-desktop > li ul li a {
  display: inline-block;
  width: 200px;
  line-height: 35px;
  padding: 0 15px;
  border-radius: 1.125rem;
  text-decoration: none;
  color: #fff;
}

.menu-desktop > li ul li:hover a {
  background: var(--primary-color);
  color: var(--black-eigengrau);
}

.menu-desktop > li ul li.divider {
  border-top: 1px dashed #7a7f91;
  margin: 10px 15px;
}

.menu-desktop > li ul.right {
  right: 0;
}

.menu-desktop > li:hover ul {
  display: flex;
}
</style>
